<template>
	<div class="fd-tk-box">
		<div class="fd-lab-tit">
			<span class="fd-lab-ico"></span>
			<span class="fd-lab-name"><i>{{model.laboratoryModel.roomCode}}</i>{{model.laboratoryModel.name}}</span>
		</div>
		<div class="fd-tk-sign">
			<span class="fd-tk-sm">实验室功能标签：</span>
			<i :class="('fd-lab-sign '+labelColor[index])" v-for="(item,index) in model.laboratoryModel.labels" :key="index">{{item}}</i>
		</div>
		<div class="fd-tk-second">
			<div class="fd-tk-half">
				<span class="fd-tk-sm">实验室基础信息：</span>
			</div>
			<div class="fd-tk-half">
				<span class="fd-tk-sm">实验室基础信息：</span>
			</div>
		</div>
		<div class="fd-tk-second">
			<div class="fd-tk-half">
				<ul class="fd-tk-img-box">
					<li class="fd-tk-img"><img :src="model.laboratoryModel.img" /></li>
					<li class="fd-data fd-data-small">
						<ul>
							<li>
								<span class="fd-data-ico fd-data-computer"></span>
								<span class="fd-data-name">{{model.laboratoryModel.Remark}}</span>
								<!-- <span class="fd-data-num">120</span> -->
							</li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="fd-tk-half">
				<ul class="fd-tk-second-data">
					<li>
						<span class="fd-lab-state-tit blue">{{model.totalCourseNum}}</span>
						<span class="fd-lab-state-sm">累计课程数量</span>
						<div class="fd-tk-second-line"></div>
					</li>
					<li>
						<span class="fd-lab-state-tit blue">{{model.totalHours}}</span>
						<span class="fd-lab-state-sm">累计实验时数</span>
						<div class="fd-tk-second-line"></div>
					</li>
					<li>
						<span class="fd-lab-state-tit blue">{{model.totalNumber}}</span>
						<span class="fd-lab-state-sm">累计实验人数</span>
					</li>
					<li>
						<span class="fd-lab-state-tit blue">{{model.totalActNum}}</span>
						<span class="fd-lab-state-sm">累计活动次数</span>
						<div class="fd-tk-second-line"></div>
					</li>
					<li>
						<span class="fd-lab-state-tit blue">{{model.totalActHours}}</span>
						<span class="fd-lab-state-sm">累计活动时数</span>
						<div class="fd-tk-second-line"></div>
					</li>
					<li>
						<span class="fd-lab-state-tit blue">{{model.totalActPeopleNum}}</span>
						<span class="fd-lab-state-sm">累计活动人数</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- 表格 -->
		<div class="fd-tk-tab-box">
			<span class="fd-tk-sm">当日课程/活动安排：</span>
			<table class="fd-tk-tab">
				<thead>
					<tr>
						<td>节次</td>
						<td>活动主题/活动目的</td>
						<td>任课老师</td>
						<td>学生专业</td>
						<td>学生人数</td>
						<td>课程进度(已完成/总)</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,index) in model.list" :key="index">
						<td>{{item.startLesson}}-{{item.endLesson}}节</td>
						<td>{{item.name}}</td>
						<td>{{item.teacherName}}</td>
						<td>{{item.majorName}}</td>
						<td>{{item.number}}</td>
						<td>{{item.schedule}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import {
		getApi
	} from '../../static/js/api.js'
	export default {
		data() {
			return {
				model: {
					laboratoryModel: {
						roomCode:'',
						name:'',
						labels: [],
						img: '',
						Remark: ''
					},
					totalCourseNum: 0,
					totalHours: 0,
					totalNumber: 0,
					totalActNum: 0,
					totalActHours: 0,
					totalActPeopleNum: 0,
					list: []
				},
				labelColor: ['bg-orange', 'bg-blue', 'bg-green', 'bg-gray', 'bg-white', 'bg-purple', 'bg-red']
			}
		},
		mounted() {
			let id = this.$route.params.id
			let that=this
			getApi('/bi/GetLaboratoryDetails', {
				id: id
			}, 'Post').then(res=>{
				if(res.IsSuccess){
					that.model=res.SuccessData
					console.log(that.model)
				}
			})
		}
	}
</script>

<style>
</style>
